import { internalActionKeys } from "../actions/internalActionKeys";
import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { Branch } from "src/common/types/branch";
import { commonActionKeys } from "src/common/actions/commonActionKeys";

export default function internalBranchesReducer(state: Branch[] = initialState.branches, action: AnyAction): Branch[] {
  switch (action.type) {
    case commonActionKeys.LOAD_BRANCHES_SUCCESS:
      return [...action.branches].sort(branchAlphabeticalCompareFunction);
    case internalActionKeys.PATCH_BRANCH_REASONS_SUCCESS:
    case internalActionKeys.SAVE_BRANCH_CONFIG_SUCCESS: {
      // Replace the updated branch
      return [
        ...state.filter(b => b.name < action.branch.name),
        action.branch,
        ...state.filter(b => b.name > action.branch.name)
      ];
    }
    case internalActionKeys.IMPORT_BRANCHES_SUCCESS:
      return [...action.branches].sort(branchAlphabeticalCompareFunction);
    case internalActionKeys.IMPORT_BRANCHES_FAILURE:
      return state;
    default:
      return state;
  }
}

const branchAlphabeticalCompareFunction = (a: Branch, b: Branch) => {
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }
  return 0;
};
